import moduleConfig from './module-config';
import netsChatSmsSession from './nets-chat-sms-session';

export default angular
  .module('app.chat-session', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsChatSmsSession', netsChatSmsSession);
